import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { Box, Link, Text } from "@radix-ui/themes";
import { DEVICE_SHARE_FORM_URL, HOSTED_SERVER_FORM_URL } from "../../consts";
import { type InterestSource, useInterestForm } from "../../hooks/useInterestForm";
import { trackEvent } from "../../utils/posthogConfig";

const LINES = {
    // A quiet line at the foot of the device list.
    device_share: {
        flag: "deviceShareInterest",
        formUrl: DEVICE_SHARE_FORM_URL,
        question: "Want to share your device with someone else?",
        event: "device_share_interest_clicked",
        box: {
            px: "5",
            py: "3",
            style: {
                borderTop: "1px solid var(--dc-card-border)",
            },
        },
    },
    // Under the first card of the connect flow, where someone picks which machine to connect.
    hosted_server: {
        flag: "hostedServerInterest",
        formUrl: HOSTED_SERVER_FORM_URL,
        question: "Want to use a server we host instead of your own computer?",
        event: "hosted_server_interest_clicked",
        box: {
            mt: "5",
        },
    },
} as const;

/**
 * One-line fake door for a feature that doesn't exist yet. Its form says so plainly. Shown only
 * while the line's dashboard flag is on.
 */
export default function InterestLine({ line, source }: { line: keyof typeof LINES; source: InterestSource }) {
    const { flag, formUrl, question, event, box } = LINES[line];
    const form = useInterestForm(flag, formUrl, source);
    if (!form) {
        return null;
    }

    return (
        <Box {...box}>
            <Text size="1" color="gray">
                {question}{" "}
                <Link
                    href={form.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="1"
                    onClick={() =>
                        void trackEvent(event, {
                            plan: form.plan,
                            surface: source,
                        })
                    }
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    Tell us
                    <ExternalLinkIcon aria-hidden="true" width="11" height="11" />
                </Link>
            </Text>
        </Box>
    );
}
